import { useListContext } from "ra-core";
import { Fragment } from "react";
import { Separator } from "@/components/ui/separator";

import { Note } from "./Note";
import { NoteCreate, type NoteReference } from "./NoteCreate";
import { InfinitePagination } from "../misc/InfinitePagination";

export const NotesIterator = ({
  reference,
  showStatus,
}: {
  reference: Exclude<NoteReference, "companies">;
  showStatus?: boolean;
}) => {
  const { isPending, error, data = [] } = useListContext();

  if (isPending || error) return null;

  return (
    <div className="mt-4">
      <NoteCreate reference={reference} showStatus={showStatus} />
      {data.length > 0 && (
        <div className="mt-4 space-y-4">
          {data.map((note, index) => (
            <Fragment key={note.id}>
              <Note note={note} isCompact={index > 0} showStatus={showStatus} />
              {index < data.length - 1 && <Separator />}
            </Fragment>
          ))}
        </div>
      )}
      <InfinitePagination />
    </div>
  );
};
